import React from "react";
import { addEmptyBlocksCreators } from "../../utils/addEmptyBlocks";
import { CreatorCard } from "../CreatorCard/CreatorCard";
import { TopCreatorsMain, TopCreatorsWrapper } from "./TopCreators.styled";

export const TopCreators = ({ creators }) => {
  return (
    <TopCreatorsWrapper>
      <div className='container'>
        <h3>Top Creator This Week</h3>
        <TopCreatorsMain>
          {creators.map((creator, i) => (
            <CreatorCard key={i} creator={creator} number={i} />
          ))}
          {addEmptyBlocksCreators(creators.length)}
        </TopCreatorsMain>
      </div>
    </TopCreatorsWrapper>
  );
};
